<template>
  <div class="section pt-5 container">
    <div class="tile is-ancestor">
      <div class="tile is-parent is-4">
        <div class="tile is-child box">
          <div class="content">
            <div class="title is-3 is-pulled-right">
              {{ timebag.hours_spent }} {{ $t("out of") }}
              {{ timebag.number_of_hours }}
            </div>
            <h1 class="title is-4">{{ timebag.customer }}</h1>
            <p>
              {{ timebag.name }}
            </p>
          </div>
        </div>
      </div>
      <div class="tile is-parent is-8">
        <div class="title is-5">{{ $t("time investment detail") }}</div>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("hours") }}</th>
              <th>{{ $t("description") }}</th>
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in timebag.timebag_services">
              <td>{{ format_date(item.date) }}</td>
              <td>{{ item.number_of_hours }}</td>
              <td>{{ item.description }}</td>
              <td>
                <div class="buttons">
                  <button
                    class="button is-small"
                    :data-tooltip="$t('report')"
                    @click="report(item)"
                  >
                    <span class="icon has-text-warning">
                      <i class="fa fa-exclamation-triangle"></i>
                    </span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <pre>{{ timebag }}</pre> -->
  </div>
</template>

<script>
import { get, error_message, format_date } from "@/utils";

export default {
  name: "TimebagShare",
  components: {},
  data() {
    return {
      timebag: {},
    };
  },
  methods: {
    format_date,
    report(item) {
      let v = this;
      console.log(item);
    },
  },
  mounted() {
    let v = this;
    get("/timebag/share", { uuid: v.$route.params.uuid })
      .then((data) => {
        v.timebag = data;
      })
      .catch((error) => {
        error_message(error);
      });
  },
  created() {},
};
</script>

<style scoped></style>
